export class Language {
  name: string;
  code: string;
  active: boolean;
  id: number;
  locale?: string;
}
